import styled from 'styled-components';
import {Space, Tag} from 'antd';

const StyledSuggestionTag = styled(Tag)`
  background-color: transparent;
  border: 1px solid ${props => props.theme.colors.neutral_5};
  border-radius: 14px;
  margin: 0;
  padding: 3px 8px;

  &:hover {
    cursor: pointer;

    border-color: ${props => props.theme.colors.primary_6};
  }
`;

const StyledSuggestionPopoverSpace = styled(Space)`
  max-width: 400px;
  width: 100%;
`;


export {
  StyledSuggestionTag,
  StyledSuggestionPopoverSpace,
};
